var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select as MuiSelect } from '@mui/material';
import { forwardRef } from 'react';
var Select = forwardRef(function (_a, ref) {
    var _b = _a.value, value = _b === void 0 ? '' : _b, onChange = _a.onChange, options = _a.options, label = _a.label, placeholder = _a.placeholder, error = _a.error, helperText = _a.helperText, renderValue = _a.renderValue, props = __rest(_a, ["value", "onChange", "options", "label", "placeholder", "error", "helperText", "renderValue"]);
    var labelId = "".concat(props.id || 'select', "-label");
    var handleChange = function (event) {
        onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value);
    };
    var defaultRenderValue = function (selectedValue) {
        if (!selectedValue)
            return '';
        var option = options.find(function (opt) { return opt.value === selectedValue; });
        return (option === null || option === void 0 ? void 0 : option.label) || '';
    };
    return (_jsxs(FormControl, { fullWidth: true, margin: "normal", error: error, ref: ref, children: [label && _jsx(InputLabel, { id: labelId, children: label }), _jsxs(MuiSelect, __assign({}, props, { displayEmpty: true, value: value, onChange: handleChange, labelId: labelId, label: label, variant: "outlined", renderValue: renderValue || defaultRenderValue, children: [placeholder && (_jsx(MenuItem, { value: "", children: _jsx("em", { children: placeholder }) })), options.map(function (option) { return (_jsx(MenuItem, { value: option.value, children: option.label }, option.value)); })] })), error && helperText && _jsx(FormHelperText, { children: helperText })] }));
});
Select.displayName = 'Select';
export default Select;
